import { useAuth0 } from '@auth0/auth0-react';
import { useParams } from 'react-router';
import useSWRMutation from 'swr/mutation';
import useAISearchProgress from './useAISearchProgress';
import { useSearchCriteria } from './useSearchCriteria';
import http from '@/Utils/HTTP/NewHttpUtils';

export interface SearchCriterionRequest {
    id: string;
    criterion: string;
}

export interface UpdateSearchParametersCriteriaRequest {
    searchCriteria: Array<SearchCriterionRequest>;
}

export const useUpdateSearchParametersCriteria = () => {
    const { getAccessTokenSilently } = useAuth0();
    const { assessmentId } = useParams();
    const { mutate: mutateSearchCriteria } = useSearchCriteria(assessmentId!);
    const { mutate: mutateAiSearchProgress } = useAISearchProgress();

    return useSWRMutation(
        `recruitments/${assessmentId}/ai-search/search-criteria`,
        async (path: string, { arg }: { arg: UpdateSearchParametersCriteriaRequest }) => {
            await http.put({
                path,
                accessToken: await getAccessTokenSilently(),
                body: arg,
            });
        },
        {
            onSuccess: async () => {
                // When criteria are updated, then we need to refetch the following data:
                // 1. search criteria
                // 2. search progress status
                // 3. identified profiles will be refetch automatically when search progress status is false
                await Promise.all([mutateAiSearchProgress(), mutateSearchCriteria()]);
            },
        },
    );
};
